import { ThemeProvider } from '@emotion/react'
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom'
import { ThemeProvider as MaterialThemeProvider } from '@mui/material/styles'
import { useEffect, useState } from 'react'
import { GoogleOAuthProvider } from '@react-oauth/google'
import { CircularProgress } from '@mui/material'

import MainLayout from './components/layouts/mainLayout/mainLayout'
import Recommendations from './pages/recommendations/[id]/Recommendations'
import Interpretations from './pages/Interpretations/[id]/Interpretations'
import InterpretationsList from './pages/Interpretations/InterpretationsList'
import RecommendationsList from './pages/recommendations/RecomendationsList'
import Config from './pages/config/Config'
import Generator from './pages/config/Generator'
import { useAppSelector } from './hooks/redux'
import PrivateRoute from './pages/login/PrivateRoutes'
import Settings from './pages/settings/settings'
import IndicatorsAndSignals from './pages/biomarkers/[id]/IndicatorsAndSignals'
import SubjectPage from './pages/subjects/Subject'
import Login from './pages/login/Login'
import DynamicStyle from "./components/dynamicStyles"
import './App.css'
import Editor from './components/CKEditor/editor'
import http from "./api/http"
import { parseUserEmail, parseActiveEmails, checkIsEditor } from './utils/userUtils'
import { ScrollToTop } from './components/ScrollToTop/ScrollToTop'
import { Redirecting, RedirectToBiomarkers } from './components/Navigation/Redirects'
import { LightTheme, themeMui } from './theme/theme'
import Register from './pages/register/Register'
import RegistrationSuccess from './pages/register/RegistrationSuccess'
import ResetPassword from './pages/auth/ResetPassword'
import AuthRedirect from './pages/login/AuthRedirect'
import AdminActivate from './pages/admin/Activate';
import BiomarkersDictionary from './pages/dictionary'
import Definitions from './pages/definitions'
import Translations from './pages/translations'
import AuditPage from './pages/audit'
import ReportsPage from './pages/reports'
import PromAdminPage from './pages/prom'



const clientID = process.env.REACT_APP_GOOGLE_CLIENT_ID || ''

const App = () => {
    const { navigate } = useAppSelector((state) => state.user)
    const [isEditor, setIsEditor] = useState(false)
    const [loading, setLoading] = useState(true)
    const userEmail = parseUserEmail()


    // console.log('userEmail', userEmail)

    // console.log("RENDER DEUBG: APP RENDER")

    // console.log('debug1098', isEditor)
    // console.log('debug2098', userEmail)


    return (<>
        <DynamicStyle></DynamicStyle>
        <ThemeProvider theme={LightTheme}>
            <MaterialThemeProvider theme={themeMui}>
                <BrowserRouter>
                    <ScrollToTop />
                    <Routes>
                        <Route path="/login" element={<AuthRedirect><Login /></AuthRedirect>} />
                        <Route path="/register" element={<AuthRedirect><Register /></AuthRedirect>} />
                        <Route path="/register/success" element={<AuthRedirect><RegistrationSuccess /></AuthRedirect>} />
                        <Route path="/reset-password" element={<AuthRedirect><ResetPassword /></AuthRedirect>} />
                        <Route path="/admin/activate" element={<AdminActivate />} />
                        <Route
                            path="*"
                            element={
                                <PrivateRoute>
                                    <MainLayout>
                                        <Routes>
                                            <Route path='/settings' element={<Settings />} />
                                            <Route path='/' element={<Redirecting />}></Route>
                                            <Route path='/config' element={<Config />}></Route>
                                            <Route path='/generator' element={<Generator />}></Route>
                                            <Route path='/dictionary' element={<BiomarkersDictionary />}></Route>
                                            <Route path='/translations' element={<Translations />}></Route>
                                            <Route path='/definitions' element={<Definitions />}></Route>
                                            <Route path='/audit' element={<AuditPage />}></Route>
                                            <Route path='/reports' element={<ReportsPage />}></Route>
                                            <Route path='/prom' element={<PromAdminPage />}></Route>
                                            <Route path={'/create-theme'} element={<SubjectPage />} />
                                            <Route path={':id/:subjects'} element={<SubjectPage />} />
                                            <Route path={':id'} element={<RedirectToBiomarkers />} />
                                            <Route path={':id/biomarkers/:indicatorId'} element={<IndicatorsAndSignals />} />
                                            <Route path=':id/diseases/create-diseases' element={<Interpretations />} />
                                            <Route path=':id/diseases/:interpretationID' element={<Interpretations />} />
                                            <Route path=':id/diseases' element={<InterpretationsList />} />
                                            <Route path=':id/recommendations/:recommendationID' element={<Recommendations />} />
                                            <Route path=':id/recommendations' element={<RecommendationsList />} />
                                        </Routes>
                                    </MainLayout>
                                </PrivateRoute>
                            }
                        />
                    </Routes>
                </BrowserRouter>
            </MaterialThemeProvider>
        </ThemeProvider>
    </>
    )
}

export default App
